// create/send chat message/s state
// documentation link tbc

const state = {

};

const getters = {

};

const mutations = {

};

const actions = {
  //send chat message/s functionality
  async sendChatMessageHandler({getters,dispatch}, {content}) {
    let data = {
      content,
      channelId: getters.getCurrentChatId
    }
    let res = await dispatch('api/chat/postMessage',data)
    dispatch('sendChatMessageCallback', res)
    return res
  },
  async sendChatMessageCallback({dispatch}, res) {
    if(!res.success) {
      //show error
      dispatch('popups/chat/errorSendingMessage')
      //potentially close chat
    } else {
      dispatch('analytics/sentChatMessage', ['Chat Message Sent', res.success])
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
